module.exports = __webpack_public_path__ + "img/1-low.8e5442bc.jpg";